import * as Yup from 'yup';

// Validation schema for custom fields
const customFieldSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nome do campo é obrigatório')
    .matches(/^[a-z0-9_]+$/, 'Use apenas letras minúsculas, números e underscores'),
  label: Yup.string().required('Rótulo é obrigatório'),
  type: Yup.string()
    .required('Tipo é obrigatório')
    .oneOf(
      [
        'text',
        'number',
        'date',
        'email',
        'phone',
        'select',
        'checkbox',
        'radio',
        'textarea',
        'heading',
        'divider',
      ],
      'Tipo inválido',
    ),
  required: Yup.boolean(),
  options: Yup.array().when('type', {
    is: type => ['select', 'checkbox', 'radio'].includes(type),
    then: Yup.array()
      .of(
        Yup.object().shape({
          label: Yup.string().required('Rótulo da opção é obrigatório'),
          value: Yup.string().required('Valor da opção é obrigatório'),
        }),
      )
      .min(1, 'Pelo menos uma opção é necessária'),
  }),
  mask: Yup.string(),
  pattern: Yup.string(),
  placeholder: Yup.string(),
});

// Main form validation schema
const validationSchema = Yup.object().shape({
  name: Yup.string().required('Nome do evento é obrigatório'),
  address: Yup.string().required('Endereço é obrigatório'),
  capacity: Yup.number()
    .required('Capacidade é obrigatória')
    .min(1, 'A capacidade deve ser pelo menos 1'),
  start_date: Yup.date().required('Data de início é obrigatória'),
  end_date: Yup.date()
    .required('Data de término é obrigatória')
    .min(Yup.ref('start_date'), 'Data de término não pode ser anterior à data de início'),
  waiting_list_enabled: Yup.boolean(),
  custom_fields: Yup.array().of(customFieldSchema),
});

export { validationSchema };
